import { defineComponent as _defineComponent } from 'vue'
import { useApi, CodeKbn } from "@/plugins/api/api";
import { ref, computed, watch } from "vue";

type Item = { text: string; value: string };

type Props = {
  value?: string;
  init?: boolean;
  kbn: CodeKbn;
};
type Emits = {
  (e: "input", val?: string): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CodeMasterSelect',
  props: {
    value: null,
    init: { type: Boolean },
    kbn: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", val?: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: string;
  init?: boolean;
  kbn: CodeKbn;
};

const { $code } = useApi();




const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const kbn = computed(() => props.kbn);
const items = ref<Item[]>([]);

const getItems = async (kbn: CodeKbn) => {
  const result = await $code(kbn);
  if (result) {
    items.value = result.map(e => ({ value: e.code, text: e.name }));
  }
};

watch(
  kbn,
  async val => {
    await getItems(val);
  },
  { immediate: true }
);

watch(items, val => {
  const firstItem = val[0]?.value;
  if (firstItem && !modelValue.value && props.init)
    modelValue.value = firstItem;
});

return { __sfc: true,$code, props, emits, modelValue, kbn, items, getItems }
}

})